import { motion } from "framer-motion";
import { ABOUT_PORTRAIT } from "@/site.config";

const fadeUp = {
  hidden: { opacity: 0, y: 36 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
};

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-20 md:py-40 bg-[#030303]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start"
        >
          {/* Portrait column */}
          <div className="lg:col-span-5 relative">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-6">
              Ch. 02 &mdash; About
            </div>

            <div className="relative aspect-[3/4] w-full overflow-hidden rounded-sm border border-white/10 bg-[#0a0a0a]">
              <img
                src={ABOUT_PORTRAIT}
                alt="Ritesh Sikri — Founder of Rubiemaze Inc"
                className="absolute inset-0 w-full h-full object-cover object-top"
                loading="lazy"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
              <div className="pointer-events-none absolute bottom-5 left-5 right-5 flex items-end justify-between">
                <div>
                  <div className="text-[10px] uppercase tracking-[0.28em] text-white/70">
                    Founder
                  </div>
                  <div className="font-display text-white text-2xl mt-1">
                    Ritesh Sikri
                  </div>
                </div>
                <div className="font-display text-[#D4AF37] text-4xl leading-none">
                  20<span className="text-[#D4AF37]/60 text-lg">yrs</span>
                </div>
              </div>
            </div>

            {/* Small caption card */}
            <div className="mt-6 grid grid-cols-2 gap-3">
              <div className="px-4 py-3 rounded-md border border-white/10 bg-white/[0.02]">
                <div className="text-[10px] uppercase tracking-[0.24em] text-white/50">
                  Discipline
                </div>
                <div className="text-white text-sm mt-1">Hospitality Strategy</div>
              </div>
              <div className="px-4 py-3 rounded-md border border-white/10 bg-white/[0.02]">
                <div className="text-[10px] uppercase tracking-[0.24em] text-white/50">
                  Craft
                </div>
                <div className="text-white text-sm mt-1">DJ &amp; Sound</div>
              </div>
            </div>
          </div>

          {/* Copy column */}
          <div className="lg:col-span-7 lg:pl-6">
            <h2 className="font-display text-white text-[36px] sm:text-4xl md:text-6xl lg:text-[80px] leading-[0.98] tracking-[-0.02em]">
              Meet{" "}
              <em className="font-editorial italic text-[#D4AF37] font-light">
                Ritesh Sikri.
              </em>
            </h2>

            <p className="mt-6 text-white/70 text-base md:text-lg max-w-xl">
              Founder of Rubiemaze Inc. DJ for over 20 years. Hospitality
              Consultant helping nightlife businesses become more profitable.
            </p>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl">
              <p className="text-white/75 leading-relaxed">
                With over two decades inside India's nightlife industry, I don't
                just understand clubs — I understand the business behind them.
              </p>
              <p className="text-white/75 leading-relaxed">
                From operations and staffing to profitability, guest experience
                and menu engineering, I help venues identify hidden revenue leaks
                and create systems that improve long-term profitability.
              </p>
            </div>

            {/* Signature bar */}
            <div className="mt-14 flex items-center gap-6 text-white/50 text-[11px] uppercase tracking-[0.28em]">
              <span className="h-px flex-1 max-w-[240px] bg-white/15" />
              <span className="text-[#D4AF37]">Founder's Note</span>
              <span className="h-px flex-1 max-w-[240px] bg-white/15" />
            </div>

            <blockquote className="mt-8 font-editorial italic text-white/85 text-xl sm:text-2xl md:text-[28px] leading-snug max-w-2xl">
              &ldquo;Most nightclubs don't have a marketing problem. They have a
              profitability problem hidden in plain sight.&rdquo;
            </blockquote>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
